/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search issues..." |
*
* @param {Manual_Qc_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_search_placeholder = /** @type {((inputs?: Manual_Qc_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des incidents...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchprobleme...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problemi di ricerca...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблемы с поиском...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problemas de búsqueda...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索问题……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索に関する問題...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोज संबंधी समस्याएं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problemas de pesquisa...")
	return /** @type {LocalizedString} */ ("Search issues...")
});